import {useState} from "react";
import Question from './Question'
export const Tree = ({treeId, questions, onTreeUpdate}) => {
    const [output, _setOutPut] = useState([])
    const setOutPut = (data) => {
        _setOutPut(data)
        onTreeUpdate && onTreeUpdate(treeId, data)
    }
    const searchTree = (
        questionId,
        answerId,
        answerPhrase,
        hierarchy,
        questionPhrase,
        answerType
    ) => {
        let indexToUpdate = 0
        let nodeToUpdate = null
        let currentChild = null
        answerPhrase=["DPD","RAD","BBT"].indexOf(answerType)>=0?undefined:answerPhrase
        answerId=["FFB"].indexOf(answerType)>=0?undefined:answerId
        let ansNode={}
        if(answerPhrase){
            ansNode.answerPhrase = answerPhrase
        }
         if(answerId){
            ansNode.answerId = answerId
        }
        const newNode = {
            questionId,
            questionPhrase,
            answers: [
                ansNode
            ],
        }
        if (!hierarchy) {
            for (let a = 0; a < output.length; a++) {
                if (output[a].questionId === questionId) {
                    indexToUpdate = a
                }
            }
            const newOutput = [...output]
            newOutput[indexToUpdate] = newNode
            setOutPut(newOutput)
        } else {
            for (let a = 0; a < hierarchy.length; a++) {
                if (output[a].questionId === hierarchy[0].questionId) {
                    indexToUpdate = a
                    nodeToUpdate = {...output[indexToUpdate]}
                    currentChild = nodeToUpdate
                } else {
                    if (currentChild.questions && currentChild.questions.length)
                        currentChild = currentChild.questions.find(
                            (x) => x.questionId === hierarchy[a].questionId
                        )[0]
                }
            }
            if (!currentChild.questions) {
                currentChild.questions = [newNode]
            } else {
                let updateQuestionAt = -1
                for (let a = 0; a < currentChild.questions.length; a++) {
                    if (currentChild.questions[a].questionId === questionId) {
                        updateQuestionAt = a
                    }
                }
                if (updateQuestionAt >= 0) {
                    const newQuestions = [...currentChild.questions]
                    newQuestions[updateQuestionAt] = newNode
                    currentChild.questions = newQuestions
                } else {
                    currentChild.questions.push(newNode)
                }
            }

            const newOutput = [...output]
            newOutput[indexToUpdate] = nodeToUpdate
            setOutPut(newOutput)
        }
    }
    return (
        <>
            {
                questions.map((q) => {
                    return (
                        <Question
                            key = {q.questionId}
                    treeId = {treeId}
                    optional = {q.optional}
                    questionPhrase = {q.questionPhrase}
                    answerType = {q.answerType}
                    questionId = {q.questionId}
                    answers = {q.answers}
                    onAnswerUpdate = {searchTree}
                    />
                )
                })
            }
        </>
    )
}
